/**
 * Get Community Accounts Use Case
 * Business logic for retrieving accounts associated with a community
 */

import type { CommunitiesRepository } from '../data/communities-repository';
import type { CommunityAccountsResponse } from '../types/community-accounts-types';

export class GetCommunityAccountsUseCase {
  constructor(private readonly repository: CommunitiesRepository) {}

  /**
   * Execute use case to get accounts for a community
   * @param communityId - The community profile ID
   */
  async execute(communityId: number): Promise<CommunityAccountsResponse> {
    try {
      // Validate community ID
      if (!communityId || communityId <= 0) {
        throw new Error('Invalid community ID');
      }

      const response = await this.repository.getCommunityAccounts(communityId);

      return response;
    } catch (error) {
      const message =
        error instanceof Error ? error.message : 'Failed to load community accounts';
      throw new Error(message);
    }
  }
}
